export const contactInterests = ["TaskDuck early access", "Partnership", "Other"];

const EVENT = "sksenq:contact-interest";

/** Ask the contact form to preselect an "Interested in" option. */
export const requestContactInterest = (interest: string) => {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: interest }));
};

export const onContactInterest = (handler: (interest: string) => void) => {
  const listener = (e: Event) => handler((e as CustomEvent<string>).detail);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
};
